import React, { Component } from 'react';
import { connect } from 'react-redux';
import _, { get } from 'lodash';

import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import Input from '../../../../components/FormElements/Input';
import ModalConfirmation from '../../../../components/ModalConfirmation';
import Table from '../../../../components/CustomTable';

import { handleFieldError, initializeForm, handleError } from '../../../../utils/form-validation';
import { formFields, options, successfullyMessage, attributeAlreadyExistsMessage } from './constant';
import { withRouter } from 'react-router-dom';

const Modal = asyncRoute(() => import('../../../../components/Modal'));
const Card = asyncRoute(() => import('../../../../components/Card'));

class Add extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      touched: {},
      errors: {},
      submited: false,
      openModal: false,
      confirmationOpen: false,
      confirmationInfo: ''
    };
  }

  componentWillMount() {
    this.initializeForm();
  }

  initializeForm() {
    let { form, errors } = initializeForm(formFields);
    this.setState({ form, errors });
  }

  toggleAlertModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
  };

  confirmationCallBack = (success, info) => {
    this.setState({ confirmationOpen: false });
  };

  handleChange = (e) => {
    let { form } = this.state;
    form[e.target.name] = e.target.value;
    this.setState({ form });
  };

  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  handleSubmit = async (e) => {
    const { handleAttributeValues } = this.props;
    let { form } = this.state;
    let { errors, valid } = handleError(form, formFields);
    if (valid) {
      const { attributeValuesList } = this.props;

      let match = attributeValuesList.find((item) => item.value == form.attributeValues);
      if (match) {
        this.toggleAlertModal(attributeAlreadyExistsMessage);
        return;
      }

      await handleAttributeValues(form);
      await this.toggleModal();
      setTimeout(() => {
        this.toggleAlertModal(successfullyMessage);
      }, 500);
    } else {
      this.setState({ errors: errors, submited: true });
    }
  };

  handleAction = (row, action) => {
    if (action.type === 'edit') {
      this.handleEdit(row);
    }
    // else if (action.type === 'delete') {
    //   this.handleDelete(row, action);
    // }
  };

  handleEdit(row) {
    const { attributeValuesList } = this.props;
    const { form } = this.state;
    let attributeValue = attributeValuesList.find((item) => item.id == row.id);
    if (attributeValue) {
      form.attributeValues = attributeValue.value;
      form.id = attributeValue.id;
      this.toggleModal(true);
      this.setState({ form });
    }
  }

  // handleDelete(row) {
  //   const { attributeValuesList, handleDeleteAttribute } = this.props;
  //   let data = attributeValuesList.filter((item) => item.id != row.id);
  //   handleDeleteAttribute(data);
  // }

  toggleModal = (reset = false) => {
    if (!reset) {
      this.initializeForm();
    }
    let { openModal } = this.state;
    this.setState({ openModal: !openModal });
  };

  attributeList = (attrData) => {
    let data = [];
    if (attrData && attrData.length) {
      data = attrData.map((item) => {
        return item;
      });
    }
    return data;
  };

  render() {
    const { submited, errors, touched, form, openModal, confirmationOpen, confirmationInfo } = this.state;
    const { attributeValuesList } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-12 text-right pt-2">
            <a href="#" onClick={() => { this.toggleModal(); }} className="btn btn-primary"><i className="mdi mdi-plus"></i>Add Attribute Value</a>
          </div>
        </div>
        {confirmationOpen && (<ModalConfirmation
          open={confirmationOpen}
          onClose={this.toggleAlertModal}
          confirmationInfo={confirmationInfo}
          handelConfirmationMessage={this.confirmationCallBack}
        />)}
        <Modal open={openModal} size='tiny' onClose={() => { this.toggleModal(); }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{form.id != undefined ? 'Edit' : 'Add'} Attribute Value</h5>
              <button type="button" onClick={() => { this.toggleModal(); }} className="close" data-dismiss="modal" aria-label="Close">
                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
              </button>
            </div>
            <div className="modal-body">
              <Card>
                <Input
                  onChange={this.handleChange}
                  onBlur={this.handleTouch}
                  value={form[formFields.attributeValues.key]}
                  setting={formFields[formFields.attributeValues.key]}
                  error={errors[formFields.attributeValues.key]}
                  submited={submited}
                  touched={touched[formFields.attributeValues.key]}
                />
              </Card>
            </div>
            <div className="modal-footer">
              <button type="button" onClick={this.handleSubmit} className="btn btn-primary" data-dismiss="modal">Save</button>
              <button type="button"  onClick={() => { this.toggleModal(); }} className="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </Modal>
        <div className="row" id="CreativeTag">
          <div className="col-12">
            <div className="table-responsive">
              <Table
                options={options}
                data={this.attributeList(attributeValuesList)}
                // data={attributeValuesList}
                handelAction={this.handleAction}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(
  state => ({
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', '')
  })
)(Add));